import {AbstractModel} from '../abstract-model';
import {Offer} from '../offer';

export class ConversionReport extends AbstractModel {
  id: number | null = null;
  offer: Offer | null = null;
  date: string = '';
  revenue: number = 0;
  tc1: string = '';
  tc2: string = '';
  tc3: string = '';
  tc4: string = '';

  getDate(): Date {
    return new Date(this.date);
  }

  override toString(): string {
    return this.date;
  }
}
